
import axios from '@/modules/axiosInterceptor';
import { apiUrlPrefix } from '../modules/staticData';

export const DeviceAttrService = {
  async getAllAttrs(mapToStringArray = false) {
    let tags = [];
    let tiers = [];
    let channels = [];
    let cities = [];
    try {
      if (tags.length > 0) {
        return {
          tags, tiers, channels, cities,
        };
      }
      const response = await axios.get(`${apiUrlPrefix}device/attr`);
      if (response.data.tags) {
        tags = mapToStringArray ? response.data.tags.map(t => t.text) : response.data.tags;
      }
      if (response.data.tiers) {
        tiers = mapToStringArray ? response.data.tiers.map(t => t.text) : response.data.tiers;
      }
      if (response.data.channels) {
        channels = mapToStringArray ? response.data.channels.map(t => t.text) : response.data.channels;
      }
      if (response.data.cities) {
        // eslint-disable-next-line
        cities = false ? response.data.cities.map(t => t.text) : response.data.cities;
      }
      return {
        tags, tiers, channels, cities,
      };
    } catch (e) {
      this.$root.$emit('notification-add', {
        content: 'Failed to fetch existing attributes list.',
        variant: 'danger',
        ttl: 10000,
      });
      return {
        tags, tiers, channels, cities,
      };
    }
  },
};
